import { configureStore } from '@reduxjs/toolkit';
import weatherReducer from './weatherSlice';
import cityListReducer from './cityListSlice';

export const store = configureStore({
  reducer: {
    weather: weatherReducer,
    cityList: cityListReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 